import React from 'react';

import { OverlayLoader } from '../UI/Overlay';
import useAuth, { KEYS } from '../hooks/useAuth';

interface LoginProps {
  location: {
    state: {
      from: {
        pathname: string;
        search: string;
      };
    };
  };
}

const Login: React.FC<LoginProps> = () => {
  const { loginWithRedirect } = useAuth();
  /** Used to tell the post login action where to go when a user's domain/email has not been verified. */
  const clientUrl = `${window.location.origin}/horizon`;
  React.useEffect(() => {
    const intendedRoute = localStorage.getItem(KEYS.INTENDED_ROUTE);
    if (intendedRoute) {
      localStorage.removeItem(KEYS.INTENDED_ROUTE);
      const intededSearch = sessionStorage.getItem(KEYS.INTENDED_SEARCH);
      if (intededSearch) {
        sessionStorage.removeItem(KEYS.INTENDED_SEARCH);
        loginWithRedirect({
          appState: { returnTo: intendedRoute, returnToSearch: intededSearch },
          client_url: clientUrl,
        });
      } else {
        loginWithRedirect({
          appState: { returnTo: intendedRoute },
          client_url: clientUrl,
        });
      }
    } else {
      loginWithRedirect({
        client_url: clientUrl,
      });
    }
  }, []);

  return <OverlayLoader />;
};

export default Login;
